export function createPluginRegistry<TPlugin extends { pluginId: string }>() {

    const plugins: { [pluginId: string]: TPlugin } = {};

    return {

        getIds() {
            return Object.keys(plugins);
        },

        use(plugin: TPlugin) {
            plugins[plugin.pluginId] = plugin;
        },

        require(id: string) {
            if (!plugins[id]) {
                throw new Error(`Unknown plugin ID '${id}'.`);
            } else {
                return plugins[id];
            }
        }
    };
}